const BASE_URL = "https://api.mandarin.weniv.co.kr/";
export default BASE_URL;
